import { ActionContext } from 'vuex';

import { ActionClass, AnalyticsState } from '../../../models';

import { ANALYTICS_CONSTS } from '../analytics.consts';

export class ClearDataAction implements ActionClass {

  public static execute({ commit }: ActionContext<AnalyticsState, any>): void {
    commit(ANALYTICS_CONSTS.mutations.clearData);
  }

}
